module.exports = "<template> <div class.bind=bootstrapClass> <slot></slot> </div> </template> ";